import { createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#ee2f58'
    },
    secondary: {
      main: '#000000'
    }
  },
  typography: {
    fontFamily: 'Open Sans',
    htmlFontSize: 12,
    fontSize: 9
  },
  overrides: {
    MuiTextField: {},
    MuiInputAdornment: {
      root: {
        marginRight: '8px'
      }
    },
    MuiCardContent: {
      root: {
        paddingTop: 0
      }
    },
    MuiCardHeader: {
      root: {
        paddingBottom: '8px',
      },
      title: {
        fontSize: '16px'
      }
    },
    MuiTypography: {
      h5: {
        fontWeight: 700
      }
    },
    MuiStepLabel: {
      label: {
        fontSize: '14px'
      },
    },
    MuiStepIcon: {
      root: {
        width: '24px',
        height: '24px'
      },
      text: {
        fontSize: '14px',
        fontWeight: 600
      }
    },
    MuiInputBase: {
      root: {
        fontSize: '14px'
      }
    },
    MuiMenuItem: {
      root: {
        fontSize: '12px'
      }
    },
    MuiFormLabel: {
      root: {
        fontSize: '14px'
      }
    },
    MuiFormHelperText: {
      root: {
        fontSize: '12px',
        marginLeft: '0 !important',
        marginTop: '8px'
      }
    },
    MuiButton: {
      label: {
        fontSize: '10px'
      }
    }
  }
});

export default theme;
